import { Box, Button, Typography } from '@mui/material';
import { Questionnaire } from 'apis/types/user-api-types';
import GenericModal from 'components/GenericModal';
import { PrettoSlider } from 'components/PreviewSliderQuestion';

type QuestionListModelProps = {
	quesionnaire: Questionnaire['questionList'];
	open: boolean;
	setOpen: (open: boolean) => void;
};

const QuestionListModal: React.FC<QuestionListModelProps> = props => {
	const { quesionnaire, open, setOpen } = props;

	return (
		<GenericModal
			open={open}
			handleClose={() => {
				setOpen(false);
			}}
			className='flex max-h-[100%] w-full flex-col rounded-lg md:max-h-[80%] md:w-[70%]'
		>
			<h5 className='text-[#F621A4]'>Questionnaire</h5>
			<ul
				className='flex-1 overflow-y-auto'
				id='questionnaire'
			>
				<div>
					<table className='quest'>
						<tbody>
							{quesionnaire?.map((val, i) => (
								<tr key={val.uuid}>
									<td className='text-[#F621A4]'>{i + 1}.</td>
									<td>
										<Typography
											variant='body2'
											component='section'
											className='question text-align-justify'
											sx={{
												lineHeight: '200%',
											}}
										>
											{val.question}
										</Typography>
										{val.rateFlag && (
											<div
												style={{
													marginBottom: '1rem',
												}}
											>
												<div>
													<div className='range-slider flex'>
														<span className='range-slider__value mr-6'>0</span>
														<PrettoSlider
															valueLabelDisplay='auto'
															aria-label='pretto slider'
															step={1}
															marks
															min={0}
															max={5}
															value={0}
															defaultValue={0}
														/>
													</div>
												</div>
											</div>
										)}
									</td>
								</tr>
							))}
						</tbody>
					</table>
				</div>
			</ul>
			<Box className='text-center'>
				<Button
					variant='outlined'
					className='mt-4'
					type='button'
					data-dismiss='modal'
					onClick={() => {
						setOpen(false);
					}}
				>
					Close
				</Button>
			</Box>
		</GenericModal>
	);
};

export default QuestionListModal;
